module.exports = __webpack_public_path__ + "img/px-1.488a2388.png";